var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "breadcrumb-item",
      class: { "breadcrumb-item--is-first": _vm.isFirst },
    },
    [
      !_vm.isFirst
        ? _c(
            "svg",
            {
              staticClass:
                "breadcrumb-item__icon pui-svg pui-icon pui-icon-right",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMidYMin slice",
                width: "16px",
                height: "16px",
                viewBox: "0 0 24 24",
                "preserve-aspect-ratio": "xMidYMin slice",
              },
            },
            [
              _c("path", {
                attrs: {
                  fill: "currentColor",
                  d: "M6 5.1L8.1 3l9 9-9 9L6 18.9l6.9-6.9z",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.isActive
        ? _c("span", { staticClass: "breadcrumb-item__link" }, [
            _vm._v(_vm._s(_vm.label)),
          ])
        : _c(
            "a",
            {
              staticClass: "breadcrumb-item__link",
              attrs: { href: _vm.href },
              on: { click: _vm.onLinkClicked },
            },
            [_vm._v(_vm._s(_vm.label))]
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }